<template>
  <Probation class="wrap" v-if="isProbationSet" @goBack="goBack"></Probation>
  <div class="wrap" v-else>
    <!-- Title -->
    <h1 class="common-header">{{ $t('1108') }}</h1>
    <!-- 内容 -->
    <div class="by-content">
      <!-- Tabs -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 日程安排 -->
        <el-tab-pane :label="`${$t('schedule')}（${scheduleList.count}）`" name="0">
          <div style="display: flex">
            <div style="width: 350px">
              <Schedule :includeSchedule="includeSchedule" @dateChange="dateChange" />
            </div>
            <!-- 日程列表 -->
            <div class="schedule-area">
              <!-- 添加日程 -->
              <div class="add-schedule">
                <el-button icon="el-icon-plus" @click="addSchedule" type="text">{{ $t('1095') }}</el-button>
              </div>
              <!-- 日程列表 -->
              <el-table :data="scheduleList.list" :height="270" :show-header="false" :empty-text="$t('no_schedule')">
                <el-table-column prop="detail" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="schedule-type">{{ scope.row.type }}</span>
                    <span class="schedule-topic">{{ scope.row.topic }}</span>
                    <span>，</span>
                    <span>{{ formatTimestamp(scope.row) }}</span>
                    <span>，</span>
                    <span>{{ scope.row.place }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="action" width="200px">
                  <template slot-scope="scope">
                    <el-button style="margin-right: 20px" @click="handleEdit(scope.row)" type="text" size="small">{{
                      $t('71')
                    }}</el-button>
                    <!-- 删除日程 -->
                    <el-button
                      slot="reference"
                      type="text"
                      size="small"
                      style="color: red"
                      @click="handleDel(scope.row.id)"
                      >{{ $t('65') }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 待办提醒 -->
        <el-tab-pane :label="`${$t('to_do_list')}（${tabCountMap && tabCountMap.invite}）`" name="1">
          <el-table :data="toDoList" style="width: 100%" :height="240">
            <el-table-column prop="staff_name" :label="$t('885')"> </el-table-column>
            <el-table-column prop="phone" :label="$t('825')"> </el-table-column>
            <el-table-column prop="action" :label="$t('70')">
              <template slot-scope="scope">
                <el-button @click="confirmAgree(scope.row)" type="text" v-if="$p('menu.settings.invite.edit')">{{
                  $t('361')
                }}</el-button>
                <el-button @click="confirmShield(scope.row)" type="text" v-if="$p('menu.settings.invite.edit')">{{
                  $t('363')
                }}</el-button>
                <el-button
                  @click="confirmRelod(scope.row)"
                  type="text"
                  style="color: red"
                  v-if="$p('menu.settings.invite.edit')"
                  >{{ $t('362') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 待转正 -->
        <el-tab-pane :label="`${$t('invite_12')}（${tabCountMap && tabCountMap.regular}）`" name="3">
          <div class="select">
            <el-form :inline="true">
              <el-form-item :label="$t('69')">
                <el-input v-model="toRegular.search_name" clearable :placeholder="$t('1109')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getStaffRegular({ init: true })">{{ $t('80') }}</el-button>
              </el-form-item>
            </el-form>
            <div>
              <!-- 设置提醒 -->
              <el-button type="primary" @click="setMessage">{{ $t('invite_14') }}</el-button>
            </div>
          </div>
          <el-table
            ref="regularTable"
            height="250"
            :data="toRegular.list"
            style="width: 100%"
            v-load="toRegular.loading"
            :loading-text="$t('989')"
          >
            <div slot="append" style="text-align: center; padding: 10px">
              <i v-if="!toRegular.finished" class="el-icon-loading" />
              <span v-else>{{ $t('1118') }}</span>
            </div>
            <!-- 姓名 -->
            <el-table-column prop="staff_name" :label="$t('22')" align="center" min-width="240px"> </el-table-column>
            <!-- 工号 -->
            <el-table-column prop="staff_code" :label="$t('25')" align="center" min-width="150px"> </el-table-column>
            <!-- 电话 -->
            <el-table-column prop="mobile" :label="$t('23')" align="center" min-width="168px"> </el-table-column>
            <!-- 部门 -->
            <el-table-column prop="department_name" :label="$t('27')" align="center" min-width="240px">
            </el-table-column>
            <!-- 职位 -->
            <el-table-column prop="job_title_name" :label="$t('24')" align="center" min-width="240px">
            </el-table-column>
            <!-- 直线上级 -->
            <el-table-column prop="manager_name" :label="$t('980')" align="center" min-width="240px"> </el-table-column>
            <!-- 入职时间 -->
            <el-table-column prop="hire_date" :label="$t('cell_time_entry_label')" align="center" min-width="168px">
            </el-table-column>
            <!-- 试用期(天) -->
            <el-table-column prop="probation_day" :label="$t('invite_7')" align="center" min-width="210px">
            </el-table-column>
            <!-- 转正时间 -->
            <el-table-column prop="formal_date" :label="$t('30')" align="center" min-width="200px">
              <template slot-scope="scope">
                <span :class="errorFormalDate(scope.row) ? 'error' : ''">{{ scope.row.formal_date }}</span>
              </template>
            </el-table-column>
            <!-- 试用期状态 -->
            <el-table-column prop="formal_state_txt" :label="$t('invite_13')" align="center" min-width="240px">
            </el-table-column>
            <!-- 员工状态 -->
            <el-table-column prop="state_txt" :label="$t('31')" align="center" min-width="192px"> </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 待离职 -->
        <el-tab-pane :label="`${$t('103')}（${tabCountMap && tabCountMap.leave}）`" name="2">
          <el-form :inline="true">
            <el-form-item :label="$t('69')">
              <el-input v-model="toResign.search" :placeholder="$t('1109')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryToLeave({ init: true })">{{ $t('80') }}</el-button>
              <el-button @click="exportExcel">{{ $t('68') }}</el-button>
            </el-form-item>
          </el-form>
          <el-table
            ref="resigTable"
            height="250"
            :data="toResign.list"
            style="width: 100%"
            v-load="toResign.loading"
            :loading-text="$t('989')"
          >
            <div slot="append" style="text-align: center; padding: 10px">
              <i v-if="!toResign.finished" class="el-icon-loading" />
              <span v-if="toResign.finished && toResign.list && toResign.list.length">{{ $t('1118') }}</span>
            </div>
            <el-table-column prop="staff_name" :label="$t('22')"> </el-table-column>
            <el-table-column prop="staff_code" :label="$t('25')"> </el-table-column>
            <el-table-column prop="mobile" :label="$t('23')"> </el-table-column>
            <el-table-column prop="department_id" :label="$t('27')"> </el-table-column>
            <el-table-column prop="job_title_id" :label="$t('24')"> </el-table-column>
            <el-table-column prop="manager_id" :label="$t('980')"> </el-table-column>
            <el-table-column prop="hire_date" :label="$t('cell_time_entry_label')"> </el-table-column>
            <el-table-column prop="leave_date" :label="$t('1111')"> </el-table-column>
            <el-table-column prop="state" :label="$t('31')"> </el-table-column>
            <el-table-column prop="formal" :label="$t('32')"> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <!-- 图表区域 -->
      <el-row :gutter="20" class="charts-main">
        <!-- 出勤情况 -->
        <el-col :xs="12" :lg="12" :xl="8">
          <div class="item">
            <p class="chart-title">
              {{ $t('staff-attendance') }}
              <el-popover width="200" placement="right" trigger="hover" :content="$t('1104')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </p>
            <Chart type="attendancePie" :chartData="attendanceData" />
          </div>
        </el-col>
        <!-- 司龄情况 -->
        <el-col :xs="12" :lg="12" :xl="8">
          <div class="item">
            <p class="chart-title">
              {{ $t('1093') }}
              <el-popover width="200" placement="right" trigger="hover" :content="$t('1103')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </p>
            <Chart type="servingBar" :chartData="servingData" />
          </div>
        </el-col>
        <!-- 组织架构 -->
        <el-col :xs="24" :lg="24" :xl="8">
          <div class="item">
            <p class="chart-title">
              {{ $t('1092') }}
              <el-popover width="200" placement="right" trigger="hover" :content="$t('1106')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </p>
            <Chart type="orgPie" :chartData="orgData" />
          </div>
        </el-col>
      </el-row>
      <!-- 员工流动 -->
      <div class="chart-bottom">
        <div class="chart-title">
          {{ $t('1094') }}
          <el-popover width="200" placement="right" trigger="hover" :content="$t('1105')">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
          <div class="chart-day">
            <el-radio-group v-model="radioSelect" @change="getFlowInfo(radioSelect)" size="small">
              <el-radio-button :label="7">{{ $t('1098') }}</el-radio-button>
              <el-radio-button :label="30">{{ $t('1099') }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <Chart type="flowBar" :chartData="flowData" />
      </div>
    </div>
    <!-- 添加/编辑日程 -->
    <el-dialog :title="isAdd ? $t('1112') : $t('1113')" :visible.sync="dialogVisible" width="30%">
      <el-form :model="scheduleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item :label="$t('schedule_type')">
          <el-select v-model="scheduleForm.type" :placeholder="$t('1114')">
            <el-option v-for="item in scheduleType" :key="item.id" :label="$t(item.name)" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 限制200个字输入，显示超50字打点 -->
        <el-form-item :label="$t('theme')" prop="topic">
          <el-input v-model="scheduleForm.topic" maxlength="200" show-word-limit :placeholder="$t('1115')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('1101')" prop="start_time">
          <el-date-picker
            v-model="scheduleForm.start_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('1116')"
            :picker-options="pickerOptionsStart"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('1102')" prop="end_time">
          <el-date-picker
            v-model="scheduleForm.end_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('1117')"
            :picker-options="pickerOptionsEnd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 限制100个字输入，显示超50字打点 -->
        <el-form-item :label="$t('location')">
          <el-input v-model="scheduleForm.place" maxlength="100" show-word-limit :placeholder="$t('629')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('66') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
    <!-- 待办——同意完善信息 -->
    <Improve ref="improve" v-if="isImprove" @handleGetPendingList="handleGetPendingList" />
  </div>
</template>

<script>
// 日程
import Schedule from './components/schedule'
import Improve from '@/views/settings/invite/modal/Improve'
import Chart from './components/chart'
import Probation from './components/probation'
import {
  typeInfoFn,
  listFn,
  createFn,
  delFn,
  editFn,
  hasSpotFn,
  attendanceFn,
  servingFn,
  orgFn,
  flowFn,
  tabCount,
  gettodayleaveoffice,
  exportleaveoffice,
  getStaffRegular // 待转正列表
} from 'api/dashboard'
import { getPendingList, inviteApproval } from 'api/settings'
import { formatDate, formatDay } from './formatDate'
// 日程默认信息
const scheduleForm = () => ({
  type: 0,
  topic: '',
  start_time: '',
  end_time: '',
  place: '',
  start_date: '',
  end_date: ''
})

export default {
  name: 'Dashboard',
  components: {
    Schedule,
    Chart,
    Improve,
    Probation
  },
  data() {
    const self = this
    return {
      // 员工流动情况天数选择
      radioSelect: 7,
      isImprove: false,
      // tabs当前索引选项
      activeName: this.$route.query.active || '0',
      scheduleList: {
        count: 0
      },
      scheduleType: [],
      // 添加日程
      dialogVisible: false,
      scheduleForm: scheduleForm(),
      rules: {
        topic: [{ required: true, message: this.$t('1120'), trigger: 'blur' }],
        start_time: [{ required: true, message: this.$t('1116'), trigger: 'blur' }],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const { start_time } = self.scheduleForm
              // 值必须存在
              if (!value) {
                return callback(new Error(self.$t('1116')))
              }
              const start = start_time && start_time.getTime()
              const end = value && ((value.getTime && value.getTime()) || value)
              // 结束时间必须大于开始时间
              if (start > end) {
                return callback(new Error(self.$t('1130')))
              }
              // 正确
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      // 开始时间——不能选今天之前的日期
      pickerOptionsStart: {
        disabledDate: time => {
          const now = Date.now()
          return time.getTime() < now - 8.64e7
        }
      },
      // 结束时间——不能比开始时间小
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.scheduleForm.start_time) {
            return time.getTime() < new Date(this.scheduleForm.start_time).getTime() - 8.64e7
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        }
      },
      // 有日程的列表
      includeSchedule: [],
      isAdd: true,
      // 代办
      toDoList: [],
      toRegular: {
        // 待转正[滚动加载]
        page: 1,
        page_size: 5,
        search_name: '',
        loading: false,
        finished: false,
        total: 0,
        list: []
      },
      // 待离职[滚动加载]
      toResign: {
        list: [],
        finished: false,
        page: 1,
        page_size: 5,
        loading: false,
        search: ''
      },
      attendanceData: {},
      servingData: {},
      orgData: {},
      flowData: {},
      tabCountMap: { invite: 0, leave: 0, regular: 0 },
      isEdit: false, // 编辑或者新增日程(通过状态关联开始结束时间)
      isProbationSet: this.$route.query.name // 点击设置提醒
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    // 结束时间必须大于开始时间
    'scheduleForm.start_time'(v) {
      if (!this.isEdit) {
        this.scheduleForm.end_time = v && v.getTime() + 3600000
      }
    }
  },
  computed: {
    errorFormalDate() {
      return function (row) {
        // 已过转正日期，试用期状态仍为试用期中，日期标红显示
        const data = new Date().getTime() > new Date(row.formal_date).getTime() + 86400000
        if (data && row.formal_state === '1') return true
        return false
      }
    }
  },
  methods: {
    init() {
      // 初次进入页面，显示当天的日程列表
      this.handleClick()
      this.getHasSpot()
      this.getAttendanceInfo()
      this.getServingInfo()
      this.getOrgInfo()
      this.getFlowInfo()
      this.getTabCount()
    },
    async getStaffRegular(params) {
      // 查询待离职
      const init = params?.init || false
      if (init) {
        this.toRegular = {
          ...this.toRegular,
          finished: false,
          page: 1
        }
      }
      this.toRegular.loading = true
      const { page, page_size, search_name } = this.toRegular
      try {
        const res = await getStaffRegular({ page, page_size, search_name })
        if (res.code === 1) {
          if (res.data.list.length < page_size) this.toRegular.finished = true
          this.toRegular.list = init ? res.data.list : this.toRegular.list.concat(res.data.list)
        }
      } catch (error) {
      } finally {
        this.toRegular.loading = false
        if (init) {
          // 待离职人员，滚动加载数据
          this.resigTableScrollEvent('regularTable', this.toRegular)
        }
      }
    },
    resigTableScrollEvent(table, data) {
      if (!this.$refs[table]) return
      const bodyWrapper = this.$refs[table].bodyWrapper
      bodyWrapper.addEventListener('scroll', () => {
        if (data.loading || data.finished) return
        // 滚动距离
        const scrollTop = bodyWrapper.scrollTop
        // 变量windowHeight是可视区的高度
        const windowHeight = bodyWrapper.clientHeight
        // 变量scrollHeight是滚动条的总高度
        const scrollHeight = bodyWrapper.scrollHeight
        if (scrollHeight - scrollTop - windowHeight <= 10) {
          data.page++
          switch (this.activeName) {
            case '2':
              this.queryToLeave() // 待离职列表
              break
            case '3':
              this.getStaffRegular() // 待转正列表
              break
          }
        }
      })
    },
    async queryToLeave(params) {
      // 查询待离职
      const init = params?.init || false
      if (init) {
        this.toResign = {
          ...this.toResign,
          finished: false,
          page: 1
        }
      }
      this.toResign.loading = true
      const { page, page_size, search } = this.toResign
      try {
        const res = await gettodayleaveoffice({ page, page_size, search })
        if (res.code === 1) {
          if (res.data.length < page_size) {
            this.toResign.finished = true
          }
          this.toResign.list = init ? res.data : this.toResign.list.concat(res.data)
        }
      } catch (error) {
      } finally {
        this.toResign.loading = false
        if (init) {
          // 待离职人员，滚动加载数据
          this.resigTableScrollEvent('resigTable', this.toResign)
        }
      }
    },
    // 导出待离职列表
    async exportExcel() {
      const { search } = this.toResign
      const res = await exportleaveoffice({
        search
      })
      if (res.code === 1) {
        const { down_load_excel } = res.data
        const { object_url } = down_load_excel
        // 下载含有url的文件
        const a = document.createElement('a') // 创建a标签
        a.setAttribute('download', '') // download属性
        a.setAttribute('href', object_url) // href链接
        a.click() // 自执行点击事件
      }
    },
    async getTabCount() {
      const res = await tabCount()
      if (res.code === 1) {
        this.tabCountMap = res.data
      }
    },
    keyValueToArr(obj) {
      return Object.entries(obj).map(item => ({
        name: item[0],
        value: item[1]
      }))
    },
    async getAttendanceInfo() {
      const res = await attendanceFn()
      if (res.code === 1) {
        this.attendanceData = this.keyValueToArr(res.data)
      }
    },
    async getServingInfo() {
      const res = await servingFn()
      if (res.code === 1) {
        this.servingData = Object.values(res.data)
      }
    },
    async getOrgInfo() {
      const res = await orgFn()
      if (res.code === 1) {
        this.orgData = this.keyValueToArr(res.data)
      }
    },
    async getFlowInfo(days) {
      const res = await flowFn({ recent_day: days || 7 })
      if (res.code === 1) {
        const obj = {
          xAxisData: Object.keys(res.data.state_1),
          entryArr: Object.values(res.data.state_1),
          leaveArr: Object.values(res.data.state_2)
        }
        this.flowData = obj
      }
    },
    // 待办提醒列表
    async handleGetPendingList() {
      const res = await getPendingList({ state: '0' })
      if (res.code === 1) {
        this.toDoList = res.data && res.data.data
      }
    },
    async getHasSpot() {
      const res = await hasSpotFn(this.dateToTimestamp(new Date()))
      if (res.code === 1) {
        const arr = Object.keys(res.data)
        this.includeSchedule = arr.map(item => {
          return formatDay(item * 1000)
        })
      }
    },
    // date对象转日期再转时间戳
    dayToTimestamp(date) {
      if (date) {
        const timestamp = new Date(formatDay(date)).getTime().toString().substr(0, 10)
        return timestamp
      } else {
        return ''
      }
    },
    // date对象转时间戳
    dateToTimestamp(date) {
      if (date) {
        const str = date.valueOf().toString().substr(0, 10)
        return str
      } else {
        return ''
      }
    },
    // 日程列表时间显示：
    // 1、时间戳转“10月27日（周二）16:00-17:00”
    // 2、时间戳转“10月27日（周二）16:00-10月28日（周三）17:00”
    formatTimestamp(row) {
      let showStr = ''
      const startStr = row.start_time * 1000
      const endStr = row.end_time * 1000
      const startTime = formatDate(startStr)
      const endTime = formatDate(endStr)
      const endHour = endTime.substr(endTime.indexOf(':') - 1, 2)
      const endMin = endTime.substr(-2)
      // 同一天
      if (new Date(startStr).toDateString() === new Date(endStr).toDateString()) {
        showStr = `${startTime}-${endHour}${endMin}`
      } else {
        showStr = `${startTime}  -  ${endTime}`
      }
      return showStr
    },
    // 日历切换
    dateChange(date) {
      const day = this.dayToTimestamp(date)
      this.getScheduleList(day)
      this.getTabCount()
    },
    async getScheduleList(day) {
      const date = day || this.dayToTimestamp(new Date())
      const res = await listFn({ day: date })
      if (res.code === 1) {
        this.scheduleList = res.data
      }
    },
    // 删除
    handleDel(id) {
      const $t = this.$t
      this.$confirm($t('confirm_delete'), $t('229'), {
        confirmButtonText: $t('131'),
        cancelButtonText: $t('66'),
        type: 'warning'
      })
        .then(async () => {
          const res = await delFn({ id })
          if (res.code === 1) {
            this.getScheduleList()
            this.getHasSpot()
          }
        })
        .catch(() => {})
    },
    // 新增/编辑日程
    handleConfirm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const { start_time, end_time } = this.scheduleForm
          const start_date = this.dayToTimestamp(start_time)
          const end_date = this.dayToTimestamp(end_time)
          const start_times = this.dateToTimestamp(start_time)
          const end_times = this.dateToTimestamp(end_time)
          const params = {
            ...this.scheduleForm,
            start_time: start_times,
            end_time: end_times,
            start_date,
            end_date
          }
          const res = this.isAdd ? await createFn(params) : await editFn(params)
          if (res.code === 1) {
            this.dialogVisible = false
            this.getScheduleList()
            // 添加点
            this.getHasSpot()
          }
        } else {
          return false
        }
      })
    },
    handleEdit(row) {
      this.isAdd = false
      this.dialogVisible = true
      this.getTypeList()
      this.isEdit = true
      this.$nextTick(() => {
        this.scheduleForm = {
          ...row,
          start_time: new Date(row.start_time * 1000),
          end_time: new Date(row.end_time * 1000)
        }
      })
    },
    // 日程类型列表
    async getTypeList() {
      const res = await typeInfoFn()
      this.scheduleType = res.data.map((val, index) => {
        return { id: index, name: val }
      })
    },
    // 添加日程
    addSchedule() {
      this.scheduleForm = scheduleForm()
      this.isEdit = false
      // 开始时间默认当前时间，结束时间默认一小时以后
      this.scheduleForm = {
        ...this.scheduleForm,
        start_time: new Date(),
        end_time: new Date(new Date().getTime() + 3600000)
      }
      this.isAdd = true
      this.dialogVisible = true
      this.getTypeList()
    },
    // tab切换
    handleClick() {
      this.$router.push({ query: { ...this.$route.query, active: this.activeName } })
      switch (this.activeName) {
        case '0':
          this.getScheduleList() // 日程列表
          break
        case '1':
          this.handleGetPendingList() // 待办提醒列表
          break
        case '2':
          this.queryToLeave({ init: true }) // 待离职列表
          break
        case '3':
          this.getStaffRegular({ init: true }) // 待转正列表
          break
      }
    },
    // 同意
    confirmAgree(item) {
      this.isImprove = true
      this.$nextTick(() => {
        this.$refs.improve.init(item)
      })
    },
    // 确认拒绝
    confirmRelod(item) {
      this.$confirm(this.$t('369', { name: item.name }), this.$t('367'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        inviteApproval({ ...item, state: 2 }).then(res => {
          this.$message.success(this.$t('886'))
          this.handleGetPendingList()
        })
      })
    },
    // 确认屏蔽
    confirmShield(item) {
      this.$confirm(this.$t('370'), this.$t('368'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        inviteApproval({ ...item, state: 3 }).then(res => {
          this.$message.success(this.$t('886'))
          this.handleGetPendingList()
        })
      })
    },
    setMessage() {
      // 设置提醒
      // 试用期设置
      this.$router.push({ path: '/staff/pemploymenter/setting', query: { active: '3', name: 'REGULAR_NOTICE_DAY' } })
    },
    goBack() {
      // 返回
      this.isProbationSet = false
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__content {
  margin-top: 25px;
}
.schedule-area {
  width: calc(100% - 350px);
  padding: 4px 0 0 15px;
  .add-schedule {
    text-align: center;
    border: 1px dashed #e4e7ed;
    margin-bottom: 30px;
    padding: 2px 0;
  }
  .schedule-type {
    font-weight: 700;
    margin-right: 15px;
  }
}

.charts-main {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .item {
    margin-top: 20px;
    transition: all 0.3s;
    height: 450px;
    align-content: space-between;
    padding-bottom: 50px;
    border: 1px solid #e4e7ed;
    background: #fff;
    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
.chart-title {
  font-size: 20px;
  line-height: 20px;
  padding: 15px;
  border-bottom: 1px solid #e4e7ed;
}
.chart-day {
  float: right;
  transform: translateY(-6px);
}
.chart-bottom {
  height: 400px;
  padding-bottom: 50px;
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  background: #fff;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
}
.select {
  display: flex;
  justify-content: space-between;
}
.error {
  color: #f56c6c;
}
</style>
